const moduleCreatePatientState = {
    namespaced: true,
    state: {
        createState: false,
    },
    getters: {
        getCreateState(state) {
            return state.createState;
        },
    },
    mutations: {
        setCreateState(state, payLoad) {
            state.createState = payLoad;
        },
    },
    actions: {
        refreshCreateState({ commit }) {
            //esto es netamente para poder gatillar el watch donde se debe refrescar luego de crear al paciente
            /**
                   * EJEMPLO:
                   *   computed: {
                        ...mapGetters({
                          getCreatePatientState: "createPatientState/getCreateState",
                        }),
                      },
                      watch: {
                        'getCreatePatientState'() {
                          if (this.getCreatePatientState) {
                            REFRESHTABLA()
                          }
                        },
                      },
                   */
            commit("setCreateState", true);
            commit("setCreateState", false);
        },
    },
};
export default moduleCreatePatientState;
